export default __webpack_public_path__ + "static/media/checkboxActive.041912d6.svg";